import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as ActPropTypes from 'types/act';

import IneligibleContactsComponent from './IneligibleContactsComponent';

class IneligibleContactsContainer extends Component {
  state = {
    showing: false,
  }

  handleClick = () => {
    this.setState(({ showing }) => ({ showing: !showing }));
  }

  render = () => {
    const { ineligibleContacts } = this.props;
    const { showing } = this.state;
    return (
      <IneligibleContactsComponent
        ineligibleContacts={ineligibleContacts}
        onClick={this.handleClick}
        showing={showing}
      />
    );
  }
}

IneligibleContactsContainer.propTypes = {
  ineligibleContacts: PropTypes.arrayOf(ActPropTypes.ineligibleContact).isRequired,
};

export default IneligibleContactsContainer;